/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ImpactPartnerResponse,
  PartnerResponse,
} from './platformapi.schemas';

import getActiveImpactPartnersMutator from '../custom-axios-instance';
import getAllPartnersMutator from '../custom-axios-instance';
import getImpactPartnerMutator from '../custom-axios-instance';

/**
 * Retrieves a list of partners
 * @summary Get Active Impact Partners
 */
export const getActiveImpactPartners = (signal?: AbortSignal) => {
  return getActiveImpactPartnersMutator<PartnerResponse[]>({
    url: `${import.meta.env['VITE_API_HOST']}/partners/active`,
    method: 'GET',
    signal,
  });
};

export const getGetActiveImpactPartnersQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/partners/active`] as const;
};

export const getGetActiveImpactPartnersQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveImpactPartners>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getActiveImpactPartners>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActiveImpactPartnersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveImpactPartners>>> = ({
    signal,
  }) => getActiveImpactPartners(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActiveImpactPartners>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActiveImpactPartnersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveImpactPartners>>
>;
export type GetActiveImpactPartnersQueryError = void;

export function useGetActiveImpactPartners<
  TData = Awaited<ReturnType<typeof getActiveImpactPartners>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActiveImpactPartners>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveImpactPartners>>,
          TError,
          Awaited<ReturnType<typeof getActiveImpactPartners>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActiveImpactPartners<
  TData = Awaited<ReturnType<typeof getActiveImpactPartners>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActiveImpactPartners>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveImpactPartners>>,
          TError,
          Awaited<ReturnType<typeof getActiveImpactPartners>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActiveImpactPartners<
  TData = Awaited<ReturnType<typeof getActiveImpactPartners>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActiveImpactPartners>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Active Impact Partners
 */

export function useGetActiveImpactPartners<
  TData = Awaited<ReturnType<typeof getActiveImpactPartners>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActiveImpactPartners>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetActiveImpactPartnersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves a list of all partners
 * @summary Get All Partners
 */
export const getAllPartners = (signal?: AbortSignal) => {
  return getAllPartnersMutator<PartnerResponse[]>({
    url: `${import.meta.env['VITE_API_HOST']}/partners/all`,
    method: 'GET',
    signal,
  });
};

export const getGetAllPartnersQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/partners/all`] as const;
};

export const getGetAllPartnersQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllPartners>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPartners>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllPartnersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllPartners>>> = ({ signal }) =>
    getAllPartners(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllPartners>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllPartnersQueryResult = NonNullable<Awaited<ReturnType<typeof getAllPartners>>>;
export type GetAllPartnersQueryError = void;

export function useGetAllPartners<
  TData = Awaited<ReturnType<typeof getAllPartners>>,
  TError = void,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPartners>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllPartners>>,
          TError,
          Awaited<ReturnType<typeof getAllPartners>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllPartners<
  TData = Awaited<ReturnType<typeof getAllPartners>>,
  TError = void,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPartners>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllPartners>>,
          TError,
          Awaited<ReturnType<typeof getAllPartners>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllPartners<
  TData = Awaited<ReturnType<typeof getAllPartners>>,
  TError = void,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPartners>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get All Partners
 */

export function useGetAllPartners<
  TData = Awaited<ReturnType<typeof getAllPartners>>,
  TError = void,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPartners>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAllPartnersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Impact Partner
 */
export const getImpactPartner = (impactPartnerParam: string, signal?: AbortSignal) => {
  return getImpactPartnerMutator<ImpactPartnerResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/partners/impact_partner/${impactPartnerParam}`,
    method: 'GET',
    signal,
  });
};

export const getGetImpactPartnerQueryKey = (impactPartnerParam?: string) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/partners/impact_partner/${impactPartnerParam}`,
  ] as const;
};

export const getGetImpactPartnerQueryOptions = <
  TData = Awaited<ReturnType<typeof getImpactPartner>>,
  TError = void | HTTPValidationError,
>(
  impactPartnerParam: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getImpactPartner>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetImpactPartnerQueryKey(impactPartnerParam);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getImpactPartner>>> = ({ signal }) =>
    getImpactPartner(impactPartnerParam, signal);

  return { queryKey, queryFn, enabled: !!impactPartnerParam, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getImpactPartner>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetImpactPartnerQueryResult = NonNullable<Awaited<ReturnType<typeof getImpactPartner>>>;
export type GetImpactPartnerQueryError = void | HTTPValidationError;

export function useGetImpactPartner<
  TData = Awaited<ReturnType<typeof getImpactPartner>>,
  TError = void | HTTPValidationError,
>(
  impactPartnerParam: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getImpactPartner>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImpactPartner>>,
          TError,
          Awaited<ReturnType<typeof getImpactPartner>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetImpactPartner<
  TData = Awaited<ReturnType<typeof getImpactPartner>>,
  TError = void | HTTPValidationError,
>(
  impactPartnerParam: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getImpactPartner>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImpactPartner>>,
          TError,
          Awaited<ReturnType<typeof getImpactPartner>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetImpactPartner<
  TData = Awaited<ReturnType<typeof getImpactPartner>>,
  TError = void | HTTPValidationError,
>(
  impactPartnerParam: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getImpactPartner>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Impact Partner
 */

export function useGetImpactPartner<
  TData = Awaited<ReturnType<typeof getImpactPartner>>,
  TError = void | HTTPValidationError,
>(
  impactPartnerParam: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getImpactPartner>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetImpactPartnerQueryOptions(impactPartnerParam, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
